import { render, staticRenderFns } from "./ProfileTabModal.vue?vue&type=template&id=476a4509&scoped=true&"
import script from "./ProfileTabModal.vue?vue&type=script&lang=js&"
export * from "./ProfileTabModal.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTabModal.vue?vue&type=style&index=0&id=476a4509&lang=scss&scoped=true&"
import style1 from "./ProfileTabModal.vue?vue&type=style&index=1&id=476a4509&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a4509",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476a4509')) {
      api.createRecord('476a4509', component.options)
    } else {
      api.reload('476a4509', component.options)
    }
    module.hot.accept("./ProfileTabModal.vue?vue&type=template&id=476a4509&scoped=true&", function () {
      api.rerender('476a4509', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/modals/ProfileTabModal.vue"
export default component.exports